<template>
  <div class="wrapper" v-if="showPage">
    <div class="img_con">
      <img class="img1" src="../../assets/imgs/Artwork@2x.png" alt="" />
      <img class="img2" src="../../assets/imgs/pay-success.png" alt="" />
    </div>
    <div class="text_con">
      <p class="text1">关联成功</p>
      <p class="text2">返回公众号体验全新服务</p>
    </div>
    <div class="btn_con">
      <van-button color="#1E8DFF" @click="handleBack">返回</van-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'LinkSuccess',
  data() {
    return {
      showPage: false
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === 'LinkMobile') {
        vm.$util.reAuth();
      } else {
        vm.getUserInfo().then(data => {
          if (!data.mobile) {
            vm.$router.replace({ name: 'LinkMobile' });
          } else {
            vm.showPage = true;
          }
        });
      }
    });
  },
  methods: {
    ...mapActions(['getUserInfo']),
    handleBack() {
      window.wx.closeWindow();
    }
  }
};
</script>

<style scoped lang="less">
.wrapper {
  height: 100%;
  background-color: #ffffff;
  .img_con {
    width: 228px;
    height: 228px;
    margin: auto;
    position: relative;
    top: 32px;
    .img1 {
      width: 100%;
      margin-top: 13.5px;
    }
    .img2 {
      width: 40px;
      position: absolute;
      right: 46px;
      bottom: 62px;
    }
  }
  .text_con {
    text-align: center;
    margin-top: 40px;
    .text1 {
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
    }
    .text2 {
      font-size: 14px;
      color: #999999;
      line-height: 14px;
      margin-top: 10px;
    }
  }
  .btn_con {
    text-align: center;
    margin-top: 28px;
    .van-button {
      width: 315px;
      height: 48px;
      line-height: 48px;
      color: #ffffff;
      font-size: 16px;
    }
  }
}
</style>
